package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import com.varabyte.kobweb.compose.foundation.layout.Column
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import io.horion.cv.api.datasource.cv.Section
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.models.ListState
import io.horion.cv.models.PersonalizedSectionType
import io.horion.cv.viewModel.CvViewModel
import org.jetbrains.compose.web.css.px

@Composable
fun ListAccordionContent(
    sectionId: String,
    cvViewModel: CvViewModel,
    onComplete: (String) -> Unit,
    onAddFormationAndClose: (String) -> Unit
) {
    val firstListId = "$sectionId-list-1"

    var lists by remember {
        mutableStateOf(
            listOf(
                ListState(
                    id = firstListId,
                    sectionId = sectionId
                )
            )
        )
    }

    var editingListId by remember {
        mutableStateOf<String?>(firstListId)
    }

    LaunchedEffect(sectionId) {
        if (
            cvViewModel.cvUiState.data.personalizedSections.none {
                it.id == firstListId
            }
        ) {
            cvViewModel.addPersonalizedSection(
                Section(
                    id = firstListId,
                    type = PersonalizedSectionType.LIST
                )
            )
        }
    }

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(30.px)
    ) {
        lists.forEach { list ->
            GenericFormCard(
                item = list,
                isEditing = editingListId == list.id,
                onEdit = { editingListId = list.id },
                onDelete = {
                    lists = lists.filterNot { it.id == list.id }
                    if (lists.isEmpty()) {
                        lists = listOf(ListState(id = "list-1", sectionId = sectionId))
                        editingListId = "list-1"
                    }
                },
                onComplete = {
                    cvViewModel.updatePersonalizedSection(
                        sectionId = list.id
                    ) { section ->
                        section.copy(
                            title = list.title
                        )
                    }

                    editingListId = null
                },
                getSummary = { t ->
                    if (t.title.isNotBlank()) {
                        SummaryData(
                            title = t.title.ifBlank { "[Titre]" },
                            subtitle = ""
                        )
                    } else {
                        null
                    }
                },
                getDefaultText = { "[Liste]"},
                formContent = { state, onDel, onComp ->
                    ListForm(
                        state = state,
                        onDelete = onDel,
                        onComplete = onComp
                    )
                }
            )
        }
        AddButton(
            text = "Ajouter un élément",
            onClick = {
                editingListId = null
                val newList = ListState(
                    id = "$sectionId-list-${lists.size + 1}",
                    sectionId = sectionId
                )

                cvViewModel.addPersonalizedSection(
                    Section(
                        id = newList.id,
                        type = PersonalizedSectionType.LIST
                    )
                )

                lists = lists + newList
            }
        )
    }
}